const ACTIVE_USER = 'activeUser';
const USER_GROUPS = 'userGroups';
const AUTHORIZED_PAGES = 'authorizedPages';

export type LocalStorageUserData = {
  firstName?: string;
  lastName?: string;
  imageUrl?: string;
  userId?: string;
  email?: string;
  permissions?: string[];
  allRoles?: string[];
  token?: string;
  userName?: string;
  avatar?: string;
  'custom:avatar'?: string;
  [key: string]: unknown;
};

export const deleteDataFromLocalStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
};

export const storeUserDataInLocalStorage = (data: object) => {
  localStorage.setItem(ACTIVE_USER, JSON.stringify(data));
};

export const getUserDataFromLocalStorage = (): LocalStorageUserData | null => {
  try {
    const userData = localStorage.getItem(ACTIVE_USER);
    return userData ? (JSON.parse(userData) as LocalStorageUserData) : null;
  } catch (error) {
    console.error('Error parsing user data from localStorage:', error);
    return null;
  }
};

export const storeUserGroupsInLocalStorage = (data: string[]) => {
  localStorage.setItem(USER_GROUPS, JSON.stringify(data));
};

export const getUserGroupsFromLocalStorage = (): string[] | null => {
  try {
    const userGroups = localStorage.getItem(USER_GROUPS);
    return userGroups ? JSON.parse(userGroups) : null;
  } catch (error) {
    console.error('Error parsing user groups from localStorage:', error);
    return null;
  }
};

export const storeAuthorizedPagesInLocalStorage = (data: string[]) => {
  localStorage.setItem(AUTHORIZED_PAGES, JSON.stringify(data));
};

export const getAuthorizedPagesFromLocalStorage = (): string[] | null => {
  try {
    const authorizedPages = localStorage.getItem(AUTHORIZED_PAGES);
    return authorizedPages ? JSON.parse(authorizedPages) : null;
  } catch (error) {
    console.error('Error parsing authorized pages from localStorage:', error);
    return null;
  }
};
